// extracted by mini-css-extract-plugin
export default {"screenXsMax":"(max-width: 768px)","container":"styles_container__0ssj8","heading":"styles_heading__4cl7D"};